import { Button, Paper, Typography } from "@mui/material";
import { myPagesFortnoxPostAuthVerify } from "API/myPages";
import { fortnoxPostAuthVerify } from "API/swesum";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const Verified = ({ fromMyPages = false }) => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [verified, setVerified] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const asyncVerifyGUIDAuth = async (guid, body) => {
      try {
        let res = null;
        if (fromMyPages) {
          res = await myPagesFortnoxPostAuthVerify(guid, body);
        } else {
          res = await fortnoxPostAuthVerify(guid, body);
        }

        if (res.status === 200) {
          setVerified(true);
        }
      } catch (error) {
        const extraMsg = error?.response?.data ? `${error.response.data}` : "";

        setError({
          msg: `Något gick fel vid verifieringen. ${extraMsg}`,
          code: error.response.status,
        });
      }
    };

    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (code && state) {
      asyncVerifyGUIDAuth(state, { authcode: code });
    } else {
      navigate("/");
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100vw" }}>
      <Paper
        sx={{
          height: "300px",
          marginTop: "40px",
          padding: "30px",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          minWidth: "750px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "30px",
          }}
        >
          {verified ? (
            <>
              <Typography variant="h3">Ni är nu verifierade!</Typography>
              <Typography>
                Ni är klara här på sidan och kan stänga eller klicka på knappen
                under för att komma till hemskärmen
              </Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ maxWidth: "200px" }}
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Hem
              </Button>
            </>
          ) : error ? (
            <>
              <Typography variant="h3">Något gick fel</Typography>
              <Typography>{error.msg}</Typography>
              <Typography>{`Error code: ${error.code}`}</Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ maxWidth: "200px" }}
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Hem
              </Button>
            </>
          ) : null}
        </div>
      </Paper>
    </div>
  );
};

export default Verified;
